import * as core from '../../../../../../../core'

import { query } from './save-term.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.save-term',
    description: 'Save Term',
    name: 'Save Term',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
